const shortDateTime = new Intl.DateTimeFormat('en-US', {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
  timeZoneName: 'short',
});

const shortDate = new Intl.DateTimeFormat('en-US', {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
});

function toValidDate(value: string | Date | null | undefined): Date | null {
  if (value instanceof Date) {
    return Number.isFinite(value.getTime()) ? value : null;
  }

  if (typeof value !== 'string' || !value.trim()) {
    return null;
  }

  const nextDate = new Date(value);
  return Number.isFinite(nextDate.getTime()) ? nextDate : null;
}

export function formatDateTime(value: string | Date | null | undefined, fallback = 'Time unavailable'): string {
  const date = toValidDate(value);
  return date ? shortDateTime.format(date) : fallback;
}

export function formatDate(value: string | Date | null | undefined, fallback = 'Date unavailable'): string {
  const date = toValidDate(value);
  return date ? shortDate.format(date) : fallback;
}

export function getLocalTimeZoneLabel(): string {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const timeZoneNamePart = new Intl.DateTimeFormat('en-US', {
    hour: 'numeric',
    timeZoneName: 'short',
  })
    .formatToParts(new Date())
    .find((part) => part.type === 'timeZoneName')?.value;

  return timeZoneNamePart ? `${timeZoneNamePart} (${timeZone})` : timeZone;
}

export function hoursUntil(value: string): number {
  const date = toValidDate(value);
  return date ? Math.round((date.getTime() - Date.now()) / 3_600_000) : 0;
}

export function isPast(value: string): boolean {
  const date = toValidDate(value);
  return date ? date.getTime() <= Date.now() : false;
}

export function toDateTimeLocalValue(value: string): string {
  const date = toValidDate(value);

  if (!date) {
    return '';
  }

  const offset = date.getTimezoneOffset();
  const local = new Date(date.getTime() - offset * 60_000);
  return local.toISOString().slice(0, 16);
}

export function fromDateTimeLocalValue(value: string): string {
  const date = toValidDate(value);
  return date ? date.toISOString() : '';
}
